// extracted by mini-css-extract-plugin
export default {"sectionTitle":"AddUserModal_sectionTitle__94sIm","divider":"AddUserModal_divider__0h62j","formContainer":"AddUserModal_formContainer__n2Ccg","footer":"AddUserModal_footer__8OllU"};